
import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Avatar,
  MenuItem,
  Divider,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

const tiposPessoa = [
  { value: 'fisica', label: 'Pessoa Física' },
  { value: 'juridica', label: 'Pessoa Jurídica' },
  { value: 'hibrida', label: 'Híbrida' }
];

function PerfilDentista({ dados, clinica, onSave, onClose }) {
  // Debug: ver dados recebidos do backend
  console.log('Dados recebidos do backend:', dados);
  const [editMode, setEditMode] = useState(false);
  const [tab, setTab] = useState(0);
  const [form, setForm] = useState({
    nome: dados?.nome || '',
    email: dados?.email || '',
    tipoPessoa: dados?.tipo_pessoa || '',
    cpf: dados?.cpf || '',
    cnpj: dados?.cnpj || '',
    nomeClinica: dados?.nome_clinica || '',
    sexo: dados?.sexo || '',
    nascimento: dados?.nascimento || '',
    endereco: dados?.endereco || '',
    telefone: dados?.telefone || '',
    cro: dados?.cro || '',
    profissao: dados?.profissao || '',
    foto: dados?.foto || '',
    ativo: dados?.ativo || '',
    is_admin: dados?.is_admin || '',
    clinica_id: dados?.clinica_id || ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (onSave) onSave(form);
    setEditMode(false);
  };

  return (
    <Box sx={{ display: 'flex', gap: 4, width: '100%', minHeight: 500 }}>
      {/* Lado esquerdo: Avatar e menu */}
      <Paper elevation={4} sx={{ width: 260, p: 3, borderRadius: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', bgcolor: 'background.paper', minHeight: 400 }}>
        <Avatar sx={{ width: 150, height: 150, mb: 2, fontSize: 36 }}>{form.nome.charAt(0)}</Avatar>
        <Divider sx={{ width: '100%', mb: 2 }} />
        <List sx={{ width: '100%' }}>
          <ListItem selected={tab === 0} button onClick={() => setTab(0)}>
            <ListItemText primary="Informações Pessoais" />
          </ListItem>
          <ListItem selected={tab === 1} button onClick={() => setTab(1)}>
            <ListItemText primary="Clínica" />
          </ListItem>
          <ListItem selected={tab === 2} button onClick={() => setTab(2)}>
            <ListItemText primary="Contato" />
          </ListItem>
        </List>
        <Divider sx={{ width: '100%', mt: 2, mb: 2 }} />
        <Button variant="text" color="primary" fullWidth sx={{ mt: 1 }}>Configurações de Conta</Button>
      </Paper>

      {/* Lado direito: Dados em abas */}
      <Paper elevation={8} sx={{ flex: 1, p: 4, borderRadius: 3, minHeight: 400 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
          <Tab label="Informações Pessoais" />
          <Tab label="Clínica" />
          <Tab label="Contato" />
        </Tabs>

        {/* Aba Informações Pessoais */}
        {tab === 0 && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField label="Nome" name="nome" value={form.nome} onChange={handleChange} disabled={!editMode} fullWidth />
            <TextField label="Email" name="email" value={form.email} onChange={handleChange} disabled={!editMode} fullWidth />
            <TextField label="CRO" name="cro" value={form.cro} onChange={handleChange} disabled={!editMode} fullWidth />
            <TextField label="Profissão" name="profissao" value={form.profissao} onChange={handleChange} disabled={!editMode} fullWidth />
          </Box>
        )}

        {/* Aba Clínica */}
        {tab === 1 && (
          clinica ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField label="Nome da Clínica" value={clinica.nome || ''} disabled fullWidth />
              <TextField label="Tipo" value={clinica.tipo || ''} disabled fullWidth />
              <TextField label="CNPJ" value={clinica.cnpj || ''} disabled fullWidth />
              <TextField label="Email da Clínica" value={clinica.email || ''} disabled fullWidth />
            </Box>
          ) : (
            <Box sx={{ p: 2 }}>
              <Typography color="text.secondary">Nenhuma informação de clínica disponível.</Typography>
            </Box>
          )
        )}

        {/* Aba Contato */}
        {tab === 2 && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField label="Telefone" name="telefone" value={form.telefone} onChange={handleChange} disabled={!editMode} fullWidth />
          </Box>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
          <Button variant="outlined" color="secondary" onClick={onClose}>Fechar</Button>
          {!editMode ? (
            <Button variant="contained" onClick={() => setEditMode(true)}>Editar</Button>
          ) : (
            <Button variant="contained" color="primary" onClick={handleSave}>Salvar Alterações</Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export default PerfilDentista;
